<template>
  <div>
    <div class="row my-1" v-for="(item, index) of items" :key="index">
      <div class="col-md-4">
        <input
          type="tel"
          v-numeric
          v-model="item.qtd"
          class="form-control"
          placeholder="Quantidade"
        />
      </div>
      <div class="col-md-4">
        <select-component class="form-control" name="parte" v-model="item.parte">
          <option value>Selecione a parte condenada</option>
          <option v-for="(option, optionKey) of options.partes" :key="optionKey" :value="option.cod_parte">{{ option.nome }}</option>
        </select-component>
      </div>
      <div class="col-md-3">
        <select-component
          class="form-control"
          name="motivo_causa_providencia"
          v-model="item.motivo_causa_providencia"
        >
          <option value>Selecione a causa</option>
          <option v-for="(option, optionKey) of options.causas" :key="optionKey" :value="option.cod_causa">{{ option.nome }}</option>
        </select-component>
        <input
          type="text"
          name="observations"
          class="form-control mt-1"
          placeholder="Outra causa"
          v-if="item.motivo_causa_providencia === 'OUTROS'" 
          v-model="item.observations"
        />
      </div>
      <div class="col-md-1">
        <input
          type="button"
          value="+"
          class="btn-control"
          v-if="index == items.length - 1"
          @click="onAddClick"
        />
        <input
          type="button"
          value="-"
          class="btn-control"
          @click="onRemoveClick(index)"
        />
      </div>
    </div>
    <div>
      <span class="text"><b>Total</b>: {{ Intl.NumberFormat('pt-BR').format(total) }}</span>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      required: false,
      default: () => ([])
    },
    options: {
      required: true
    },
  },
  data: () => ({
    items: [],
  }),
  computed: {
    total() {
      return this.items.reduce((acc, curr) => acc + (parseInt(curr.qtd) || 0), 0);
    }
  },
  methods: {
    onAddClick() {
      this.items.push({});
    },
    onRemoveClick(index) {
      this.items.splice(index, 1);
      if (this.items.length === 0) {
        this.items.push({});
      }
    },
  },
  mounted() {
    this.items = this.value;
    if (!this.items || !this.value.length) {
      this.items.push({});
    }
  },
};
</script>
<style lang="scss" scoped>
.btn-control {
  width: 20px;
  height: 20px;
  border: none;
  border-radius: 50%;
  box-shadow: none;
  background: #fc6836;
  font-size: 21px;
  line-height: 21px;
  cursor: pointer;
}
</style>
